
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export const useBookingReview = (bookingId: string) => {
  return useQuery({
    queryKey: ['booking-review', bookingId],
    queryFn: async () => {
      console.log('Checking for existing review for booking:', bookingId);
      
      const { data, error } = await supabase
        .from('reviews')
        .select('id')
        .eq('booking_id', bookingId)
        .maybeSingle();

      if (error) {
        console.error('Error checking for existing review:', error);
        throw error;
      }

      console.log('Existing review check result:', data);
      return data;
    },
    enabled: !!bookingId,
  });
};
